const state = {
    customFields: [],
    loading: []
};

export default state;